import GlobalStyles from '@mui/material/GlobalStyles';

const AppGlobalStyles = () => (
    <GlobalStyles styles={{
        '*': {
            boxSizing: 'border-box',
            margin: 0,
            padding: 0,
            fontFamily: 'Roboto',
        },
        html: {
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            height: '100%',
            width: '100%',
        },
        body: {
            height: '100%',
            width: '100%',
        },
        a: {
            textDecoration: 'none',
        },
        '#root': {
            height: '100%',
            width: '100%',
        },
        '.generic-loader': {
            position: 'relative',
        },
        '.MuiLinearProgress-colorPrimary': {
            background: '#a1ade0',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
        },
        '.MuiLinearProgress-colorPrimary .MuiLinearProgress-barColorPrimary': {
            background: '#2e53e6',
        },
    }} />
);

export default AppGlobalStyles;
